module.exports = __webpack_public_path__ + "static/media/kia_2.06db892b.jpg";